// extracted by mini-css-extract-plugin
export default {"address":"sihtVm5B+INGnWRTCUjtdQ=="};